// eslint-disable-next-line no-shadow
export const UserPageMutations = {
    SET_PAGE_TYPE: 'SET_PAGE_TYPE',
    GET_USER_DETAIL: 'GET_USER_DETAIL',
    RESET_USER_DETAIL: 'RESET_USER_DETAIL',
    GET_HUB_LIST: 'GET_HUB_LIST',
};
export const ActionTypes = {
    setPageType: 'setPageType',
    resetUserDetail: 'resetUserDetail',
    isUserIdExist: 'isUserIdExist',
    getUser: 'getUser',
    postUser: 'postUser',
    putUser: 'putUser',
    getHubListByDist: 'getHubListByDist',
    getHubList: 'getHubList',
};
